// Minimal i18n scaffold. Default locale: it. Ready to extend with en, etc.
import { createContext, useContext, useState } from "react";

const dictionaries = {
  it: {
    "app.tagline": "Business messaging, connected.",
    "nav.dashboard": "Dashboard",
    "common.save": "Salva",
    "common.cancel": "Annulla",
  },
};

const I18nContext = createContext({ locale: "it", t: (k) => k, setLocale: () => {} });

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(localStorage.getItem("cx_locale") || "it");
  const t = (key, fallback) => dictionaries[locale]?.[key] ?? fallback ?? key;
  const change = (l) => { setLocale(l); localStorage.setItem("cx_locale", l); };
  return <I18nContext.Provider value={{ locale, t, setLocale: change }}>{children}</I18nContext.Provider>;
}

export const useTranslation = () => useContext(I18nContext);
